export default {
    name: 'public',
    state: {
        isPublic: false
    },
    getters: {
        getIsPublic: state => {
            return state.isPublic
        },
    },
    mutations: {
        PUBLIC: (state, payload) => {
            state.isPublic = payload;
        }
    },
    actions: {
        SET_PUBLIC(store, payload) {
            store.commit('PUBLIC', payload)
        }
    }
}